import rep_main from '@/store/reports/rep_main'
// import rep_sort from '@/store/reports/rep_sort'

export default {
  state: rep_main.state,
  getters: rep_main.getters,
  actions: rep_main.actions,
  mutations: rep_main.mutations,
}
